"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Brand = void 0;
var BaseEntity_1 = require("../../../models/concrete/BaseEntity");
;
var Brand = /** @class */ (function (_super) {
    __extends(Brand, _super);
    function Brand(data) {
        var _this = _super.call(this, data) || this;
        _this.startedAt = data.started_at;
        _this.endedAt = data.ended_at;
        _this.title = data.title;
        _this.slug = data.slug;
        _this.url = data.url;
        _this.label = data.label;
        _this.iconFileId = data.icon_file_id;
        _this.icon = data.icon;
        _this.imageId = data.image_id;
        _this.image = data.image;
        _this.description = data.description;
        _this.text = data.text;
        _this.isShowProducts = data.is_show_products;
        _this.isShowInList = data.is_show_in_list;
        _this.minTotal = data.min_total;
        _this.discountType = data.discount_type;
        _this.discountValue = data.discount_value;
        _this.bonusType = data.bonus_type;
        _this.bonusValue = data.bonus_value;
        return _this;
    }
    return Brand;
}(BaseEntity_1.BaseEntity));
exports.Brand = Brand;
//# sourceMappingURL=Brand.js.map